// @ts-nocheck legacy file transformed to TS
/*
  _____  ______ _____  _____  ______ _____       _______ ______ _____
 |  __ \|  ____|  __ \|  __ \|  ____/ ____|   /\|__   __|  ____|  __ \
 | |  | | |__  | |__) | |__) | |__ | |       /  \  | |  | |__  | |  | |
 | |  | |  __| |  ___/|  _  /|  __|| |      / /\ \ | |  |  __| | |  | |
 | |__| | |____| |    | | \ \| |___| |____ / ____ \| |  | |____| |__| |
 |_____/|______|_|    |_|  \_\______\_____/_/    \_\_|  |______|_____/

 Components should be doing their own data fetching using established patterns Use Table directly instead
*/

import React from 'react'
import PropTypes from 'prop-types'
import PromiseData from 'legacy/components/PromiseData'
import Table from './Table'

const PromiseTable = props => {
  const { promise, ...rest } = props

  return (
    <PromiseData promise={promise}>
      {(isLoading, isError, data, meta) => (
        <Table meta={meta} data={data} isLoading={isLoading} isError={isError} {...rest} />
      )}
    </PromiseData>
  )
}

PromiseTable.propTypes = {
  promise: PropTypes.object,
  onClickRow: PropTypes.func,
  paginated: PropTypes.bool,
  getTrProps: PropTypes.func,
  getTheadTrProps: PropTypes.func,
  getTableProps: PropTypes.func,
  onPageChange: PropTypes.func,
  noDataText: PropTypes.string,
}

export default PromiseTable
